import React, { useContext } from "react";
import "./Intro.css";
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/vector2pink.png";
import boy from "../../img/prueba1.gif";
import glassesimoji from "../../img/energydrink.png";
import thumbup from "../../img/gamedev.png";
import crown from "../../img/webpc.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import Github from "../../img/githubblue.png";
import LinkedIn from "../../img/linkedinblue.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "white" : "" }}>Hi! I'm</span>
          <span>Francisco Cedermaz</span>
          <span>
            A creative and proactive person looking for new challenges that test
            my current capabilities as a Full Stack Developer.
          </span>
        </div>
        <Link to="contact" smooth={true} spy={true}>
          <button className="button i-button">Hire me</button>
        </Link>
        {/* social icons */}
        <div className="i-icons">
          <a target="_blank" href="https://www.github.com/francedermaz">
            <img src={Github} alt="" />
          </a>
          <a target="_blank" href="https://www.linkedin.com/in/francedermaz">
            <img src={LinkedIn} alt="" />
          </a>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img class="vector1" src={Vector1} alt="" />
        <img class="vector2" src={Vector2} alt="" />
        <img class="boy" src={boy} alt="" />
        {/* animation */}
        <motion.img
          class="drink"
          style={{
            width: "5em",
          }}
          initial={{ top: "-9%", left: "-17%" }}
          whileInView={{ top: "-9%", left: "-4%", transform: "rotate(+12deg)" }}
          transition={transition}
          src={glassesimoji}
          alt=""
        />

        <motion.div
          initial={{ top: "-4%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Full Stack" text2="Developer" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Game" text2="Developer" />
        </motion.div>
        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
